import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { ApiService, DEFAULT_TIMEOUT } from './api.service';
import { HttpTokenInterceptor } from './http.token.interceptor';
import { StoreState } from './states/store.state';

@NgModule({
  declarations: [],
  imports: [
    NgxsModule.forRoot([StoreState], {
      developmentMode: !environment.production,
      selectorOptions: {
        injectContainerState: false,
      },
    }),
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: DEFAULT_TIMEOUT, useValue: 60000 },
    ApiService    
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
